import {StyleSheet} from 'react-native';

// Structural styles only (no colors) — text/input colors come from the
// theme at the call sites (docs/DARK-MODE.md).
export default StyleSheet.create({
  container: {
    marginTop: 24,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '16px',
  },
  flex1Width292: {
    flex: 1,
    maxWidth: 292,
    minWidth: 292,
  },
});
